import { V1Heart } from "src/pages/reports/ffi/v1/types";

export const meta: Record<V1Heart, Opportunity> = {
    churchEngagement: {
        title: "Church Engagement",
        prologue: "Administrators are deeply devoted to a local church body (Romans 12:4-5; Hebrews 10:25).",
    },
    personalDevotions: {
        title: "Personal Devotions",
        prologue:
            "Administrators, teachers, alumni, and staff are diligent about engaging with the Bible, including reading and memorizing Scripture (Psalms 19:7-8; 119:15).",
    },
    spiritualMaturity: {
        title: "Spiritual Maturity",
        prologue:
            "Parents and teachers desire to grow in understanding and living according to the Bible (Hebrews 5:12-14, 6:1; John 15:5; Philippians 1:9).",
    },
    hopefulness: {
        title: "Hopefulness",
        prologue:
            "Students and alumni express optimism and purposefulness about their lives (Job 13:15; Jeremiah 29:11; Romans 5:5).",
    },
    reconciliation: {
        title: "Reconciliation",
        prologue:
            "Students seek forgiveness from others and offer forgiveness when it is asked of them (Matthew 6:15; Ephesians 4:32; Colossians 3:13).",
    },
    reverence: {
        title: "Reverence",
        prologue:
            "Administrators, staff, and students revere God and live their lives in submission to His authority (1 Samuel 12:24; Proverbs 1:7; Hebrews 12:9; 2 Timothy 3:16-17).",
    },
};
